export default "__VITE_ASSET__DgF7OGz3__"